/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReasonCode } from '../../models/reason-code';

export interface GetReasonCodes$Params {
  entityClass: string;
  entityId: string;
  primaryTypes: Array<string>;
  secondaryTypes?: Array<string>;
}

export function getReasonCodes(
  http: HttpClient,
  rootUrl: string,
  params: GetReasonCodes$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<ReasonCode>>> {
  const rb = new RequestBuilder(rootUrl, getReasonCodes.PATH, 'get');
  if (params) {
    rb.path('entityClass', params.entityClass, {});
    rb.path('entityId', params.entityId, {});
    rb.query('primaryTypes', params.primaryTypes, {});
    rb.query('secondaryTypes', params.secondaryTypes, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReasonCode>>;
    })
  );
}

getReasonCodes.PATH = '/reason-codes/{entityClass}/{entityId}';
